<div class="container-fluid reporting-page px-3 px-md-4 py-3">
  <div class="row">
    <div class="col-md-6 mx-auto text-center text-white">
      <app-alert [titulo]="'Reportes Individuales'"></app-alert>
    </div>
  </div>
  <div class="row g-3 my-3 align-items-stretch reporting-filters-row">
    <div class="col-12 col-md-5">
      <mat-card class="report-card h-100">
        <mat-card-content class="report-selection-content">
          <app-selection-report-individual-list (selectedOptionEmit)="getReporteSelected($event)">
          </app-selection-report-individual-list>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-12 col-md-7">
      <app-filter-individual (filterEmit)="search($event)" (printExcelEmit)="printExcel($event)">
      </app-filter-individual>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-table-report-individual [setTableParams]="paramEntity" [dataSource]="dataSource" [columns]="columns">
      </app-table-report-individual>
    </div>
  </div>
</div>
